import { render, staticRenderFns } from "./VolumesCard.vue?vue&type=template&id=2d150277&scoped=true"
import script from "./VolumesCard.vue?vue&type=script&lang=js"
export * from "./VolumesCard.vue?vue&type=script&lang=js"
import style0 from "./VolumesCard.vue?vue&type=style&index=0&id=2d150277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d150277",
  null
  
)

export default component.exports